import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=1ebfb752&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=1ebfb752&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebfb752",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ebfb752')) {
      api.createRecord('1ebfb752', component.options)
    } else {
      api.reload('1ebfb752', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=1ebfb752&scoped=true", function () {
      api.rerender('1ebfb752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/medicaid/claims/Main.vue"
export default component.exports